import {Command} from "../command";
import {CommandType} from "../commandType";
import {EstimateRowType} from "../state/estimateRowType";
import * as $ from "jquery";
import {EstimateSubtotalRowPopupParams} from "../../components/estimate-subtotal-row-popup/estimate-subtotal-row-popup";
import {PopupType} from "../popups/popupType";
import {PopupMode} from "../popups/popup";
import {Application} from "../application";
import * as ko from "knockout";

export class EditEstimateSubtotalRowCommand implements Command {
    constructor(private app: Application) {

    }

    type: CommandType = CommandType.EditEstimateSubtotalRow;
    canExecute = ko.computed(() => {

        let estimate = this.app.state.estimate();

        if (!estimate)
            return false;

        if (estimate.selectedRow().length == 0)
            return false;


        let row = estimate.selectedRow()[0];

        if (!row)
            return false;

        return row.type == EstimateRowType.subtotal;
    });
    canNotExecute = ko.computed(() => {
        return !this.canExecute();
    });
    execute(): JQueryPromise<any> {
        if (!this.canExecute())
            return $.Deferred().reject().promise();

        return this.app.popupsManager.show<EstimateSubtotalRowPopupParams>(PopupType.estimateSubtotalRow, false,<EstimateSubtotalRowPopupParams> {
            popupMode: PopupMode.Edit
        });
    }

    name = "Edit Subtotal Row";
}


// WEBPACK FOOTER //
// ./ClientApp/services/commands/editEstimateSubtotalRowCommand.ts